module.exports = __webpack_public_path__ + "static/media/branding-img23.c6788fe0.jpg";